import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ADMIN_TOKEN_KEY = "carefleet_admin_token";

export const submitDemoRequest = async (payload) => {
  const response = await axios.post(`${API}/demo-requests`, payload);
  return response.data;
};

export const fetchDemoRequests = async () => {
  const response = await axios.get(`${API}/demo-requests`);
  return response.data;
};

export const createLead = async (payload) => {
  const response = await axios.post(`${API}/leads`, payload);
  return response.data;
};

export const adminLogin = async (payload) => {
  const response = await axios.post(`${API}/admin/login`, payload);
  return response.data;
};

export const fetchAdminSession = async (token) => {
  const response = await axios.get(`${API}/admin/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const fetchLeads = async (token, filters = {}) => {
  const params = {};
  if (filters.enquiryType && filters.enquiryType !== "all") {
    params.enquiry_type = filters.enquiryType;
  }
  if (filters.status && filters.status !== "all") {
    params.status = filters.status;
  }

  const response = await axios.get(`${API}/admin/leads`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  });
  return response.data;
};

export const updateLeadStatus = async (token, leadId, status) => {
  const response = await axios.patch(
    `${API}/admin/leads/${leadId}/status`,
    { status },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return response.data;
};

export const exportLeadsCsv = async (token, filters = {}) => {
  const params = {};
  if (filters.enquiryType && filters.enquiryType !== "all") {
    params.enquiry_type = filters.enquiryType;
  }
  if (filters.status && filters.status !== "all") {
    params.status = filters.status;
  }

  const response = await axios.get(`${API}/admin/leads/export`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
    responseType: "blob",
  });
  return response.data;
};

export const getAdminToken = () => window.localStorage.getItem(ADMIN_TOKEN_KEY);

export const setAdminToken = (token) => window.localStorage.setItem(ADMIN_TOKEN_KEY, token);

export const clearAdminToken = () => window.localStorage.removeItem(ADMIN_TOKEN_KEY);